import { Alert, AlertDescription, AlertIcon } from '@reward-platform/lift/components'
import { Box, Section } from '@alto-avios/alto-ui'
import { useTranslations } from 'next-intl'
import { useFeatureFlag } from '~/context/featureFlag'
import { usePlatformConfig } from '~/context/platform'
import styles from './HouseholdUnavailableAlert.module.scss'

export const HouseholdUnavailableAlert = () => {
  const t = useTranslations('components.household_unavailable_alert')
  const { opCo } = usePlatformConfig()
  const isIberiaHouseholdEnabled = useFeatureFlag('iberia-hh-enabled')

  if (opCo === 'IB' && !isIberiaHouseholdEnabled) {
    return (
      <Section
        alignItems="flexStart"
        justifyContent="flexStart"
        flexDirection="column"
        paddingY={0}
        backgroundColor="base"
        className={styles.aboveScrim}
      >
        <Section.Container>
          <Box paddingY="xs" width="100%" flexDirection="column">
            <Alert status="warning" data-testid="household-unavailable-alert">
              <AlertIcon iconName="triangle-exclamation" iconSize="1.25x" />
              <AlertDescription>{t('message')}</AlertDescription>
            </Alert>
          </Box>
        </Section.Container>
      </Section>
    )
  }

  return null
}
